import queryString from "query-string";

export const fetchUnvisitedPlaces = (): Function => (
  state,
  actions,
): Promise<void> => {
  const {
    api,
    clientID,
    unvisitedPlaces: {
      category: { id: categoryID },
      keyword = "",
      pagination: { pageNumber, pageSize, pageCount },
      portifolio: { id: portifolioID },
      since,
      until,
    },
  } = state;

  const headers = new Headers({ authorization: state.authorization });
  const fetching = fetch(
    `${api}/v1/unvisited-places/${clientID}?${queryString.stringify({
      categoryID,
      keyword,
      pageNumber,
      pageSize,
      portifolioID,
      since,
      until,
    })}`,
    { headers },
  );

  fetching
    .then(response => response.json())
    .then(({ places }) => {
      actions.setUnvisitedPlaces({
        pageNumber,
        pageSize,
        pageCount,
        places,
        isLoaded: true,
      });
      actions.fetchUnvisitedPlacesCount({
        categoryID,
        clientID,
        portifolioID,
        since,
        until,
      });
    })
    .catch(reason => actions.setUnvisitedPlacesFailed({ reason }));

  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      loadingUnvisitedPlaces: true,
    },
  };
};
